import { useQuery } from '@tanstack/react-query';
import type { ElapsedTimeResponse } from '@/shared/types/elapsed-time';
import { fetchElapsedTimes } from '@/entities/task/api/elapsed-time';
import { fetchTaskElapsedV2 } from '@/entities/task/api/tasks-v2';
import { useAuthStore } from '@/store/auth';

/**
 * Списания времени по задаче.
 *
 * Маршрутов два: legacy `/tasks/{id}/elapsed` (числовые id, ответ
 * `{ result: [{ Seconds }] }`) и нативный `/v2/tasks/{id}/elapsed` (UUID,
 * массив с `seconds`). Под нативной сессией legacy отвечает 403, поэтому
 * источник выбирается по сессии, а ответ приводится к одной форме — вызывающие
 * (карточки мобильного календаря, статус времени) правок не требуют.
 */
export function useElapsedTimes(taskId: string) {
  const isNativeSession = useAuthStore((state) => Boolean(state.nativeUser));

  return useQuery<ElapsedTimeResponse, Error>({
    queryKey: ['elapsed-times', taskId, isNativeSession ? 'v2' : 'legacy'],
    queryFn: async () => {
      if (!isNativeSession) {
        return fetchElapsedTimes(taskId);
      }

      const items = await fetchTaskElapsedV2(taskId);

      return {
        result: items.map((item) => ({
          Seconds: item.seconds ?? 0,
        })),
      } as ElapsedTimeResponse;
    },
    enabled: !!taskId,
  });
}
